<template>

    <v-dialog v-model="model" max-width="900">
        <toolbar-page title="Widget installation" icon="mdi-link">
            <template slot="buttons">
                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-btn @click="model=false" v-on="on" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </template>
        </toolbar-page>

        <v-card>
            <v-card-text class="pa-4">

                <h3>
                    WIDGET INSTALLATION
                </h3>
                <p>
                    Members App can be embedded to any website by placing the following javascript anywhere on the
                    target web page. The javascript will attach click handler on the specified HTML -element.
                    This can be a link or a button or any HTML element.
                </p>
                <h3>CONFIGURATION OBJECT</h3>
                <p>
                    <b>url:</b> Members App URL<br>
                    <b>type:</b> Can be either "tab" or "dialog"<br>
                    <b>target:</b> Target HTML element<br>
                    <b>width:</b> Dialog width<br>
                    <b>height:</b> Dialog height<br>
                </p>

                <v-card color="white"  class="code pa-4">
                    &lt;button id="my-button"&gt;Login&lt;/button"&gt;<br><br>
                        &lt;script&gt;{{ exampleCode }}<br><br>
                    snma({<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;url: '{{widgetUrl}}',<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;width: '90%',<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;height: '90%',<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;target: 'my-button',<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;type: 'tab',<br>
                    });<br>
                    <br>
                    &lt;/script&gt;
                </v-card>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapActions} from 'vuex';
import ToolbarPage from "../../../components/UI/ToolbarPage";

const vuexModule = 'VuexStore';

export default {

    components: {
        ToolbarPage,
        Json
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        widgetUrl: {
            type: String | null,
            required: true,
        }
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value)
            }
        },

        exampleCode() {

            return '!function(e,n,s,a,m,t,o){e.SampleNinjaMembersApp="snma",e.snma=e.snma||function(){(e.snma.q=e.snma.q||[]).push(arguments)},' +
                'e.snma.l=1*new Date,t=n.createElement("script"),o=n.getElementsByTagName("script")[0],' +
                't.async=1,t.src=a,o.parentNode.insertBefore(t,o)}' +
                '(window,document,0,"//' + window.location.hostname + '/js/membersApp.js");';
        }
    },

    data() {
        return {}
    },
}
</script>

<style scoped>

.code {
    font-family: Lucida Console, Courier, monospace;
    color: #3d4852;
}

</style>
